import type { CSSProperties } from "react"

// One rotating pastel accent per Project Type pill — the same palette Lead's
// Overview cards use for their icon circles, cycled by index rather than
// invented per-type, since a type has no color of its own to key off.
const TYPE_PILL_ACCENTS = [
  { color: "#2A7D8C", background: "#E7F3F1" },
  { color: "#16A34A", background: "#ECF9EF" },
  { color: "#FF8A3D", background: "#FFF1E8" },
  { color: "#6366F1", background: "#EEF0FE" },
  { color: "#0284C7", background: "#E6F6FE" }
] as const

const typePillStyle = (index: number): CSSProperties => {
  const accent = TYPE_PILL_ACCENTS[index % TYPE_PILL_ACCENTS.length]
  return { color: accent.color, background: accent.background, border: "none" }
}

export { TYPE_PILL_ACCENTS, typePillStyle }
